import React from 'react';
import { Box } from '@mui/material';
import './DetailRow.css';

type PillTone = 'success' | 'warning' | 'neutral';

interface StatusPillProps {
  label: string;
  tone: PillTone;
  loading?: boolean;
}


export const StatusPill: React.FC<StatusPillProps> = ({ label, tone, loading }) => (
  <span className={`detail-status-pill detail-status-pill--${tone}`}>
    {loading && <span className="detail-status-pill-spinner" />}
    {label}
  </span>
);

interface DetailRowProps {
  label: string;
  children: React.ReactNode;
}


export const DetailRow: React.FC<DetailRowProps> = ({ label, children }) => (
  <Box className="detail-row">
    <span className="detail-row-label">{label}</span>
    <span className="detail-row-value">{children}</span>
  </Box>
);
